import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { useTranslation } from '@common/hooks/useTranslation';
import { videoQuestionsRules } from '../../rules';
import { VideoQuestionsField } from './VideoQuestionsField';

type Props<T extends FieldValues> = UseControllerProps<T> & {
  label?: string | React.ReactNode;
  disabled?: boolean;
  businessName?: string;
};

export function VideoQuestions<T extends FieldValues>({
  name,
  control,
  label,
  disabled,
  businessName
}: Props<T>) {
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={videoQuestionsRules(t)}
      render={({ field: { onChange, value }, formState }) => (
        <VideoQuestionsField
          label={label}
          disabled={formState.disabled || disabled}
          onChange={onChange}
          value={value}
          error={formState?.errors[name]?.message as string}
          businessName={businessName}
        />
      )}
    />
  );
}
